import {AxiosError, AxiosResponse} from "axios";
import {injectable} from "inversify";

import "@/extensions/date.extensions";

import {ApiService} from "@/services/apiService";
import {IOrganizationService} from "@/injection/interfaces";
import {IFullOrganization, IOrganization} from "@/types/entities/organization";
import {SucceededOrNotResponse} from "@/types/responses";
import {IEditOrganizationRequest, IEditOwnOrganizationRequest} from "@/types/requests";

@injectable()
export class OrganizationService extends ApiService implements IOrganizationService {
  public async getAllOrganizations(): Promise<IOrganization[]> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/organizations`;
    const response = await this._httpClient.get<AxiosResponse<IOrganization[]>>(route)
      .catch(function (error: AxiosError): AxiosResponse<IOrganization[]> {
        return error.response as AxiosResponse<IOrganization[]>;
      });
    return response.data as IOrganization[];
  }

  public async getOrganizationWithId(id: string): Promise<IFullOrganization> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/organizations/${id.toString()}`;
    const response = await this._httpClient.get<AxiosResponse<IFullOrganization>>(route)
      .catch(function (error: AxiosError): AxiosResponse<IFullOrganization> {
        return error.response as AxiosResponse<IFullOrganization>;
      });
    return response.data as IFullOrganization;
  }

  public async getMyOrganization(lang = "fr"): Promise<IFullOrganization> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/organizations/mine?lang=${lang}`;
    const response = await this._httpClient.get<AxiosResponse<IFullOrganization>>(route)
      .catch(function (error: AxiosError): AxiosResponse<IFullOrganization> {
        return error.response as AxiosResponse<IFullOrganization>;
      });
    return response.data as IFullOrganization;
  }

  public async getMySyndicate(): Promise<IFullOrganization> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/syndicate/mine`;
    const response = await this._httpClient.get<AxiosResponse<IFullOrganization>>(route)
      .catch(function (error: AxiosError): AxiosResponse<IFullOrganization> {
        return error.response as AxiosResponse<IFullOrganization>;
      });
    return response.data as IFullOrganization;
  }

  public async editMyOrganization(request: IEditOwnOrganizationRequest): Promise<SucceededOrNotResponse> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/organizations/mine`
    const response = await this
      ._httpClient
      .put<any, AxiosResponse<any>>(
        route,
        request,
        this.headersWithFormDataContentType())
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>
      })
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }

  public async editOrganizationWithId(id: string, request: IEditOrganizationRequest): Promise<SucceededOrNotResponse> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/organizations/${id}`
    const response = await this
      ._httpClient
      .put<any, AxiosResponse<any>>(
        route,
        request,
        this.headersWithFormDataContentType())
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>
      })
    const succeededOrNotResponse = response.data as SucceededOrNotResponse
    return new SucceededOrNotResponse(succeededOrNotResponse.succeeded, succeededOrNotResponse.errors)
  }
}